import React from 'react';
import { Space, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import ShareLinks from './buttons/ShareLinksButton';
import Player from './buttons/PlayerButton';
import AcastPlusButton from './buttons/AcastPlusButton';
import Headliner from './headliner/HeadlinerIntegrationModal';
import useAcastPlus from '../hooks/useAcastPlus';
import { useGetShow } from '../hooks/query/show';

const ActionsBar = () => {
  const { episodeId } = useParams();
  const { show, isShowLoading } = useGetShow();

  const { isEnabled: hasAcastPlusEnabled, hasAcastPlusBYOP } = useAcastPlus({
    showId: show?._id,
  });

  return isShowLoading ? (
    <Skeleton.Button active={true} block={true} />
  ) : (
    <Space direction="horizontal" wrap>
      <Player />
      {episodeId && <Headliner />}

      <ShareLinks />
      {
        // until we make Plus-Manage work for Access tiers, we shouldn't link to it for Access shows.
        hasAcastPlusEnabled && !hasAcastPlusBYOP && (
          <AcastPlusButton providerShowId={show?.showId} />
        )
      }
    </Space>
  );
};

export default ActionsBar;
